//product-list-container will be main class

function init_slide_images() {
    const slide_parents = new $$('.product-list-container .product_wrapper');

    slide_parents.each(parent => {

        default_selected_image(parent);
        const parent_colors = new $$('.custom_colors_option', parent);

        parent_colors.each(color => {
            new $$('.color-swatch', color).on('click', (item) => {
                active_class_remove(new $$('.color-swatch', color))
                active_class_add(item);
                change_image(parent, item);
            })
        })

        function active_class_remove(element) {
            element.each(elem => {
                elem.classList.remove('active');
            })
        }

        function active_class_add(elem) {
            elem.classList.add('active');
        }

        function change_image(slide_parent, selected_option) {
            const images = new $$('.image_box img', slide_parent);

            images.each(image => {
                if (image.alt === selected_option.dataset.value) {
                    active_class_remove(new $$('.image_box img', slide_parent));
                    active_class_add(image);
                }
            })
        }

        function default_selected_image(slide_parent) {
            const images = new $$('.image_box img', slide_parent);
            const colors = new $$('.custom_colors_option .color-swatch', slide_parent);

            images.elems.length > 0 && images.elems[0].classList.add('active');
            colors.elems.length > 0 && colors.elems[0].classList.add('active');
        }
    })
}

function buildVariantsSwatches(containerClass) {
    if (!window.swatches) return
    const swatchesArray = document.querySelectorAll(containerClass + ' .color-swatch');
    if (!swatchesArray) return
    swatchesArray.forEach(color => {
        const option = color.dataset.optionValue;
        if (!window.swatches[option]) return;

        let optionColors = window.swatches[option] || {};
        let optionColor1 = optionColors.color1 || "";
        let optionColor2 = optionColors.color2 || "";
        let optionColor3 = optionColors.color3 || "";

        if (optionColor2 === "" || optionColor2 === "rgba(0,0,0,0)") {
            color.setAttribute("id", "one-color");
        }
        if (optionColor3 != "" || optionColor3 === "rgba(0,0,0,0)") {
            color.setAttribute("id", "three-colors");
        }
        color.querySelector('.swatch').children[0].style.backgroundColor = optionColor1;
        color.querySelector('.swatch').children[1].style.backgroundColor = optionColor2;
        color.querySelector('.swatch').children[2].style.backgroundColor = optionColor3;
        color.style.display = 'block';
    });
}
init_slide_images();
buildVariantsSwatches('.custom_colors_option');